import { SyntheticEvent, useEffect, useState } from 'react';
import { isMobile } from 'react-device-detect';
import styled from 'styled-components';
import appStorePath from 'Assets/images/appStore.svg';
import googlePlayPath from 'Assets/images/googlePlay.svg';
import { LinkAppMobile } from '../Socials/SocialGroup/LinkAppMobile';
import { QrCodeModal } from './QrCodeModal';

const BrandContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const Logo = styled.span`
  display: block;
  margin: 0 auto 2.4rem;
  font-family: 'Montserrat' !important;
  font-size: 2.4rem;
  font-weight: 500;
  letter-spacing: 0.2rem;
  line-height: 1;
  color: #fff;
  text-transform: uppercase;
`;

const StoreLinks = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1.6rem;
  margin: 0 auto 4.4rem;

  a.footer_apps_ico {
    display: block;
    border: 1px solid rgba(255, 255, 255, 0.35);
    border-radius: 0.6rem;
    overflow: hidden;
  }

  img {
    display: block;
    height: 4rem;
    width: auto;
  }
`;

export const FooterBrand = () => {
  const [isMobileDevice, setIsMobileDevice] = useState(false);
  const [isQrModalOpen, setIsQrModalOpen] = useState(false);

  useEffect(() => {
    setIsMobileDevice(isMobile);
  }, []);

  const handleStoreClick =
    (device: 'iOs' | 'Android') => (e: SyntheticEvent) => {
      localStorage.setItem('typeOfDeviceClicked', device);
      if (!isMobileDevice) {
        e.preventDefault();
        setIsQrModalOpen(true);
      }
    };

  return (
    <BrandContainer>
      <a href="/">
        <Logo>Bazarchic</Logo>
      </a>
      <StoreLinks>
        <LinkAppMobile
          img={appStorePath}
          url={
            isMobileDevice
              ? 'http://fr.bazarchic.com/bzc_app_redirect.html'
              : undefined
          }
          target={isMobileDevice ? '_self' : undefined}
          onClick={handleStoreClick('iOs')}
        />
        <LinkAppMobile
          img={googlePlayPath}
          url={
            isMobileDevice
              ? 'http://fr.bazarchic.com/bzc_app_redirect.html'
              : undefined
          }
          target={isMobileDevice ? '_self' : undefined}
          onClick={handleStoreClick('Android')}
        />
      </StoreLinks>
      <QrCodeModal
        isOpen={isQrModalOpen}
        onClose={() => setIsQrModalOpen(false)}
      />
    </BrandContainer>
  );
};

export default FooterBrand;
